import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetRecommendationByActionId = createAsyncThunk(
  "DropDowns/GetRecommendationByActionId",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetRecommendationByActionId",
        parameters
      );

      const data = response.data.result;
      console.log(data, "dataaaa");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const RecommendationByActionId = createSlice({
  name: "DropDownRecommendationByActionId",
  initialState: {
    DropDownRecommendationByActionId: [],
    loadingDropDownRecommendationByActionId: false,
    errorDropDownRecommendationByActionId: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetRecommendationByActionId.pending, (state, action) => {
        state.loadingDropDownRecommendationByActionId = true;
        state.DropDownRecommendationByActionId = action.payload;
        state.errorDropDownRecommendationByActionId = null;
      })
      .addCase(GetRecommendationByActionId.fulfilled, (state, action) => {
        state.loadingDropDownRecommendationByActionId = false;
        state.DropDownRecommendationByActionId = action.payload;
      })
      .addCase(GetRecommendationByActionId.rejected, (state, action) => {
        state.loadingDropDownRecommendationByActionId = false;
        state.errorDropDownRecommendationByActionId = action.payload;
      });
  },
});

export default RecommendationByActionId.reducer;
